import { useState, type FC } from 'react';
import { NudosTextInput } from '../../../../../components/NudosComponents';
import { IMinDetails, ISerials } from '../../../../../types/orders';

interface NewSerialProps {
  existSerials: boolean;
  serials: ISerials[];
  setNewSerialText: React.Dispatch<React.SetStateAction<string>>;
  index: number;
  serialByProducts: string[];
  setSerialByProducts: React.Dispatch<React.SetStateAction<string[]>>;
  errorList?: IMinDetails[];
  removeError?: (serial: string) => void;
  placeHolder: string;
  disabled?: boolean;
  defaultValue?: string;
}

const NewSerial: FC<NewSerialProps> = ({
  existSerials,
  serials,
  setNewSerialText,
  index,
  serialByProducts,
  setSerialByProducts,
  errorList,
  removeError,
  placeHolder,
  disabled,
  defaultValue
}) => {
  const [errorText, setErrorText] = useState('');
  const [currentValue, setCurrentValue] = useState(defaultValue ? 'Serial de stock' : serialByProducts[index] || '');

  const isStockSerial = !!defaultValue;
  
  const getErrorText = (
    newSerial: string,
    isDuplicate: boolean,
    existSerials: boolean,
    serials: ISerials[]
  ): string => {
    if (newSerial === '') return '';
    if (isDuplicate) return 'Este serial ya existe';
    if (existSerials && serials?.some(s => s?.serial !== null && s?.serial === newSerial)) {
      return 'Este serial ya existe en los productos originales';
    }
    return '';
  };

  const handleSerialChange = (evt: string) => {
    if (isStockSerial) return;

    const newSerial = evt;
    setCurrentValue(newSerial);
    setNewSerialText(newSerial);

    if (errorList && errorList.length > 0) {
      removeError?.(serialByProducts[index]);
    }

    const isDuplicate = serialByProducts.some((serial, idx) => serial === newSerial && idx !== index);
    setErrorText(getErrorText(newSerial, isDuplicate, existSerials, serials));

    const updatedSerials = [...serialByProducts];
    updatedSerials[index] = newSerial;
    setSerialByProducts(updatedSerials);
  };

  const duplicateSerialInDatabase = (serial: string, errorList: IMinDetails[]) => {
    if (!errorList) return '';
    const searchSerialError = errorList?.find(error => error?.serial === serial?.trim());
    if (searchSerialError) return 'Este serial ya esta asignando a una herramienta';
    return '';
  };

  return (
    <div className={`mt-3 ${existSerials ? 'serialInputWrapper' : ''}`}>
      <NudosTextInput
        isFilled={false}
        defaultValue={defaultValue ? 'Serial de stock' : currentValue}
        label={defaultValue ? "Serial de stock" : "Serial nuevo"}
        placeholder={placeHolder}
        customClassName={!existSerials ? 'customSerialInput' : ''}
        handleChange={handleSerialChange}
        errorText={errorText || duplicateSerialInDatabase(serialByProducts[index], errorList || [])}
        isDeactivated={isStockSerial || disabled}
      />
    </div>
  );
};

export default NewSerial;
